exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.image {\n  position: relative;\n  display: block;\n  min-height: 240px;\n}\n.image__wrapper {\n    position: relative;\n    display: block;\n    overflow: hidden;\n    max-height: 680px;\n}\n", "", {"version":3,"sources":["/home/blissadmin/azagent/_work/39/s/src/assets/components/image/image-simple.scss"],"names":[],"mappings":";AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;CAAE;AACpB;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;CAAE","file":"image-simple.scss","sourcesContent":[".image {\n  position: relative;\n  display: block;\n  min-height: 240px; }\n  .image__wrapper {\n    position: relative;\n    display: block;\n    overflow: hidden;\n    max-height: 680px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js!./src/assets/components/image/image-simple.scss
// module id = 568
// module chunks = 52